import type { Id } from "@convex/_generated/dataModel";
import { createFileRoute } from "@tanstack/react-router";
import { ActivityTab } from "@/features/employee/activity-tab";

export const Route = createFileRoute("/_app/_main/team/$employeeId/activity")({
  component: () => <ActivityTab employeeId={Route.useParams().employeeId as Id<"employees">} />,
});
